import React from 'react';
import { SvgIcon } from 'core/icons';

const ControlButton = ({
  text,
  screenReaderText,
  icon,
  isVisible,
  analyticsKey,
  onClick,
  className
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <button
      type="button"
      className={className}
      data-dtm={analyticsKey}
      onClick={onClick}>
      <SvgIcon name={icon} aria-hidden="true" />
      <span aria-hidden="true">{text}</span>
      <span className="show-for-sr">{screenReaderText}</span>
    </button>
  );
};

export default ControlButton;
